import { render } from "./klb-kua.vue?vue&type=template&id=ed9aef08&scoped=true"
import script from "./klb-kua.vue?vue&type=script&lang=js"
export * from "./klb-kua.vue?vue&type=script&lang=js"

import "./klb-kua.vue?vue&type=style&index=0&id=ed9aef08&scoped=true&lang=css"

import exportComponent from "E:\\vue_yclcp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed9aef08"]])

export default __exports__